import { Component } from '@angular/core';
import { AnyCaaRecord } from 'dns';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';

@Component({
  selector: 'app-missing-configuration',
  standalone: false,
  templateUrl: './missing-configuration.component.html',
  styleUrl: './missing-configuration.component.scss'
})
export class MissingConfigurationComponent {
  data: any; //tempplate name
  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef, private bsModalServc: BsModalService
  ){

  }

  onAddType(){
    this.bsModalServc.setDismissReason("addType");
    this.modalRef.hide();
  }

  cancelAddType(){
    this.bsModalServc.setDismissReason("cancel");
    this.modalRef.hide();
  }
}
